import ActiveTab from './SubComponents/ActiveTab';
import HistoryTab from './SubComponents/HistoryTab';
import RequestMealModal from './Modal/RequestMealModal';
import RequestSummary from './Modal/RequestSummary';
import ExtraMealApp from './Functionality/ExtraMealApp';
import DeleteModal from './../../../Modals/DeleteModal';
import { SUB_VIEW_MODEL } from '../../DiningOrders/Model/Models';
/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
const ExtraMeal = ({
    subView,
    setSubView,
    setBodyForExport,
    showRequestModal,
    setShowRequestModal,
    extraMealType,
    setExtraMealType,
    option,
    setOption,
    setModuleId,
    setSearch,
    simpleSearch,
    setSimpleSearch
}) => {
    const {
        DEV,
        permission,
        t,
        activeStep,
        deleteMealRequestShow,
        setDeleteMealRequestShow,
        showSummaryModal,
        setShowSummaryModal,
        userTypeId,
        itemSelected,
        setItemSelected,
        modified,
        setModified,
        qrContainerRef,
        searchElement,
        setSearchElement,
        deleteSelectedMealRequest,
        handleShowActive,
        handleShowHistory,
        handleDownload,
        userId
    } = ExtraMealApp({
        subView,
        setSubView,
        setOption,
        setModuleId
    });

    return (
        <>
            {subView === SUB_VIEW_MODEL.REQUEST_MEALS.ACTIVE && (
                <>
                    <ActiveTab
                        t={t}
                        userTypeId={userTypeId}
                        modified={modified}
                        setModified={setModified}
                        setItemSelected={setItemSelected}
                        setShowSummaryModal={setShowSummaryModal}
                        setShowRequestModal={setShowRequestModal}
                        setExtraMealType={setExtraMealType}
                        setDeleteMealRequestShow={setDeleteMealRequestShow}
                        handleDownload={handleDownload}
                        handleShowActive={handleShowActive}
                        handleShowHistory={handleShowHistory}
                        subView={subView}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                    />
                </>
            )}
            {subView === SUB_VIEW_MODEL.REQUEST_MEALS.HISTORY && (
                <>
                    <HistoryTab
                        DEV={DEV}
                        permission={permission}
                        userTypeId={userTypeId}
                        modified={modified}
                        setModified={setModified}
                        setItemSelected={setItemSelected}
                        setShowSummaryModal={setShowSummaryModal}
                        handleDownload={handleDownload}
                        handleShowActive={handleShowActive}
                        handleShowHistory={handleShowHistory}
                        subView={subView}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        option={option}
                        setBodyForExport={setBodyForExport}
                        setSearch={setSearch}
                        simpleSearch={simpleSearch}
                        setSimpleSearch={setSimpleSearch}
                    />
                </>
            )}

            { (showRequestModal) &&
                <RequestMealModal
                    onHide={() => {
                        setItemSelected(null);
                        setExtraMealType(null);
                        setShowRequestModal(false);
                    }}
                    showRequestModal={ true }
                    itemSelected={itemSelected}
                    setModified={setModified}
                    userId={userId}
                    extraMealType={extraMealType}
                />
            }

            { (itemSelected  && showSummaryModal) &&
                <RequestSummary
                    item={itemSelected}
                    open={showSummaryModal}
                    onHide={() => {
                        setItemSelected(null);
                        setShowSummaryModal(false)
                    }}
                    activeStep={activeStep}
                    subview={subView}
                    qrContainerRef={qrContainerRef}
                    handleDownloadQr={handleDownload}
                />
            }
            <DeleteModal
                show={deleteMealRequestShow}
                onHide={() => {
                    setDeleteMealRequestShow(false)
                    setItemSelected(null);
                }}
                onClickFn={() => deleteSelectedMealRequest(itemSelected.id)}
                data={[itemSelected]}
                title_modal={t('delete')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('meal_request')}
            />
        </>
    );
};

export default ExtraMeal;
